import {Col, Modal, Row} from 'antd'
import styles from './index.module.less'

const AnnouncementModal = props => {
  const { open, onClose, data } = props
  return (
    <Modal open={open} onCancel={onClose} footer={false} width="80%">
      <div className={styles.announcementTitle}>{data?.title}</div>
      <div className={styles.announcementSubTitle}>
        <Row gutter={12}>
          <Col>系统公告</Col>
          <Col>{data?.time}</Col>
        </Row>
      </div>

      <div
        className={styles.announceContent}
        dangerouslySetInnerHTML={{ __html: data?.content }}
      ></div>
    </Modal>
  )
}

export default AnnouncementModal
